// src/components/AddProjectButton.js
import React, { useState } from 'react';
import Modal from 'react-modal';
import './AddProjectButton.css'; // Importez le fichier CSS pour les styles

const AddProjectButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleButtonClick = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div>
      <div
        className="add-project-button"
        onClick={handleButtonClick}
        title="À propos du projet"
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12.01" y2="8"></line>
        </svg>
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={handleCloseModal}
        contentLabel="À propos du projet"
        className="modern-modal"
        overlayClassName="modern-overlay"
      >
        <div className="modal-header">
          <h2>À propos du projet</h2>
          <button className="close-button" onClick={handleCloseModal}>&times;</button>
        </div>
        <div className="modal-content">
          <h3>État du projet</h3>
          <p>Ce projet est actuellement en cours de développement. Les projets architecturaux sont en cours d'ajout progressif à la base de données. Vous pouvez suivre l'avancement du développement sur notre <a href="/devlog">page de devlog</a>.</p>
          
          <h3>Participation</h3>
          <p>Ce projet est participatif ! Si vous souhaitez contribuer en ajoutant des projets architecturaux, n'hésitez pas à nous contacter par email.</p>
          
          <h3>Fonctionnalités du site</h3>
          <ul>
            <li><strong>Légende interactive :</strong> Située à droite de la carte, elle vous permet de filtrer et découvrir les projets par catégorie. Cliquez sur les différentes options pour afficher ou masquer les types de projets.</li>
            
            <li><strong>Recherche intelligente :</strong> En haut de la page, une barre de recherche vous permet de trouver des projets par adresse ou par nom. Cliquez sur l'icône dans la barre pour basculer entre les différents types de recherche.</li>
            
            <li><strong>Localisation et itinéraire :</strong> En bas à droite de la carte, vous trouverez les options de localisation et d'itinéraire. Utilisez-les pour vous positionner ou obtenir des directions vers les projets qui vous intéressent.</li>
          </ul>
          
          <p>Pour participer au projet ou pour toute question, contactez-nous à : <a href="mailto:contact@arkastra.fr">contact@arkastra.fr</a></p>
        </div>
      </Modal>
    </div>
  );
};

export default AddProjectButton;
